module.exports = __webpack_public_path__ + "static/media/01_window.9475b794.PNG";